<template>
  <Marco>
    <div slot="content">
      <div class="main-title">
        <h1 class="title">{{ step.pregunta }}</h1>
      </div>

      <div class="field-row">
        <div class="field">
          <p class="label">{{ step.subPregunta }}</p>
          <select v-model="opcionSelected">
            <option
              v-for="opcion in opciones"
              :value="opcion"
              :key="opcion.id"
              :hidden="opcion.id == 'TITULO'"
              >{{ opcion.descr }}</option
            >
          </select>
        </div>
        <div v-if="mensajeError" class="noValido">{{ mensajeError }}</div>
      </div>
    </div>

    <a slot="botonAtras" href="#" @click.prevent="$router.go(-1)">Atrás</a>
    <a slot="botonSiguiente" href="#" @click.prevent="siguiente()">
      Siguiente</a
    >
  </Marco>
</template>

<script>
import actions from "@/util/actions.js";
export default {
  store: ["step"],

  data() {
    return {
      opcionSelected: "",
      mensajeError: "",
      opciones: []
    };
  },

  mounted() {
    this.step.posiblesRespuestas.forEach(respuesta => {
      this.opciones.push(respuesta);
      if (respuesta.id == "TITULO") this.opcionSelected = respuesta;
    });

    let valorAnterior = actions.getSeleccionAnterior(this.$route.params.np);
    if (valorAnterior != null) this.opcionSelected = valorAnterior;
  },

  methods: {
    siguiente: async function() {
      if (this.opcionSelected.id == "TITULO") {
        this.mensajeError = "Seleccionar una opción";
        return;
      }
      actions.setSeleccion(this.$route.params.np, this.opcionSelected);
      this.$emit("elegido", this.opcionSelected.id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
